import script from './SdsContextMenu.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu',{staticClass:"sds-context-menu",attrs:{"role":"menu"}},[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-8af442a2_0", { source: ".sds-context-menu[data-v-8af442a2]{display:inline-flex;flex-direction:column;margin:0;padding:0;border-radius:var(--radius-md);box-shadow:var(--shadows-system-default);background-color:var(--system-bg-elevation-layer-1)}.sds-context-menu[data-v-8af442a2]>:first-child{border-top-left-radius:var(--radius-md);border-top-right-radius:var(--radius-md)}.sds-context-menu[data-v-8af442a2]>:last-child{border-bottom-left-radius:var(--radius-md);border-bottom-right-radius:var(--radius-md)}.sds-context-menu[data-v-8af442a2]>:not(:last-child){border-bottom:var(--stroke-default) solid var(--system-border-on-elevation-tertiary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-8af442a2";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
